import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gfm_logo2.png'


const _withScopeId = n => (_pushScopeId("data-v-8112fc5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-bar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-full w-full" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Image",
    style: {"max-height":"40px"}
  })
], -1))
const _hoisted_3 = { class: "p-menuitem-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Menubar, { model: _ctx.items }, {
      start: _withCtx(() => [
        _hoisted_2
      ]),
      item: _withCtx(({ item }) => [
        _createVNode(_component_router_link, {
          to: item.to,
          class: "p-menuitem-link",
          role: "menuitem"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(["p-menuitem-icon", item.icon])
            }, null, 2),
            _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'home' }))),
          label: "Anmelden",
          disabled: "true"
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}